var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "free-table" },
    [
      !_vm.columns || _vm.columns.length == 0
        ? _c(
            "div",
            { staticClass: "nocolumns", staticStyle: { color: "#fd349c" } },
            [
              _vm._v(
                "This table doesn't have table header, this is a data error."
              ),
            ]
          )
        : _c(
            "el-table",
            {
              staticClass: "table",
              attrs: { data: _vm.hereValue, border: "" },
            },
            [
              _vm._l(_vm.columns, function (thv, thk) {
                return _c("el-table-column", {
                  key: thk,
                  attrs: {
                    label: thv.text,
                    align: "center",
                    "header-align": "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm.disableEdit
                            ? _c("span", {}, [
                                _vm._v(
                                  _vm._s(_vm.findTdContent(scope.row, thk)) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.findTdOthersContent(scope.row, thk)
                                    )
                                ),
                              ])
                            : !_vm.disableEdit && !thv.options
                            ? _c("el-input", {
                                staticClass: "td-input",
                                attrs: {
                                  value: _vm.findTdContent(scope.row, thk),
                                  placeholder: _vm.$t(
                                    "freetable_input_placeholder",
                                    { key: thv.text }
                                  ),
                                },
                                on: {
                                  input: (e) => _vm.tdChange(scope.row, thk, e),
                                },
                              })
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        value: _vm.findTdContent(
                                          scope.row,
                                          thk
                                        ),
                                        placeholder: _vm.$t(
                                          "freetable_select_placeholder",
                                          { key: thv.text }
                                        ),
                                        clearable: "",
                                      },
                                      on: {
                                        change: (e) =>
                                          _vm.tdChange(scope.row, thk, e),
                                      },
                                    },
                                    _vm._l(thv.options, function (v, k) {
                                      return _c("el-option", {
                                        key: k,
                                        attrs: { value: v, label: v },
                                      })
                                    }),
                                    1
                                  ),
                                  ["其他", "others"].includes(
                                    _vm.findTdContent(scope.row, thk)
                                  )
                                    ? _c("el-input", {
                                        attrs: {
                                          value: _vm.findTdOthersContent(
                                            scope.row,
                                            thk
                                          ),
                                          placeholder: _vm.$t(
                                            "freetable_input_others_placeholder",
                                            { key: thv.text }
                                          ),
                                        },
                                        on: {
                                          input: (e) =>
                                            _vm.tdOthersChange(
                                              scope.row,
                                              thk,
                                              e
                                            ),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _vm.getUser.userType == "2" && !_vm.disableEdit
                ? _c("el-table-column", {
                    attrs: {
                      width: "80",
                      align: "center",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ $index }) {
                            return _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#fd349c",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onRowDeleteClick($index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON_DELETE")))]
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      2080268300
                    ),
                  })
                : _vm._e(),
            ],
            2
          ),
      !_vm.disableEdit
        ? _c(
            "div",
            { staticClass: "addmore", on: { click: _vm.onAddMoreClick } },
            [
              _c("img", {
                staticClass: "add-icon",
                attrs: { src: _vm.AddIcon },
              }),
              _c("div", { staticClass: "add-text" }, [
                _vm._v(_vm._s(_vm.$t("freetable_add_more"))),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }